import {
  FETCH_FAQS_DATA,
  FETCH_FAQS_SUCCESS,
  FETCH_FAQS_FAILURE,
  FETCH_FAQS_EDIT_DATA,
  FETCH_FAQS_EDIT_SUCCESS,
  FETCH_FAQS_EDIT_FAILURE,
} from "./actionTypes";

export const fetchFaqsData = () => ({
  type: FETCH_FAQS_DATA,
});

export const fetchFaqsSuccess = (data) => ({
  type: FETCH_FAQS_SUCCESS,
  payload: data,
});

export const fetchFaqsFailure = (error) => ({
  type: FETCH_FAQS_FAILURE,
  payload: error,
});

export const fetchFaqsEditData = (id) => ({
  type: FETCH_FAQS_EDIT_DATA,
  payload: id,
});

export const fetchFaqsEditSuccess = (data) => ({
  type: FETCH_FAQS_EDIT_SUCCESS,
  payload: data,
});

export const fetchFaqsEditFailure = (error) => ({
  type: FETCH_FAQS_EDIT_FAILURE,
  payload: error,
});
